import { render, staticRenderFns } from "./CodesQuota.vue?vue&type=template&id=24de24de"
import script from "./CodesQuota.vue?vue&type=script&lang=js"
export * from "./CodesQuota.vue?vue&type=script&lang=js"
import style0 from "./CodesQuota.vue?vue&type=style&index=0&id=24de24de&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports